module.exports = __webpack_public_path__ + "img/psd_des_1.e6a36533.jpg";